import { useEffect, useRef } from 'react';

const RUFFLE_CDN = 'https://unpkg.com/@ruffle-rs/ruffle';

export const RufflePlayer = ({ swfUrl, gameName }) => {
  const containerRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const container = containerRef.current;

    const loadRuffle = async () => {
      // Inject Ruffle CDN script if not already present
      if (!window.RufflePlayer) {
        await new Promise((resolve, reject) => {
          const existing = document.querySelector(`script[data-ruffle]`);
          if (existing) {
            resolve();
            return;
          }
          const script = document.createElement('script');
          script.src = RUFFLE_CDN;
          script.dataset.ruffle = 'true';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      if (cancelled || !container) return;

      // Wait for Ruffle to be ready
      const ruffle = window.RufflePlayer.newest();
      const player = ruffle.createPlayer();
      player.style.width = '100%';
      player.style.height = '100%';
      container.appendChild(player);
      playerRef.current = player;

      if (swfUrl) {
        player.load(swfUrl);
      }
    };

    loadRuffle().catch(console.error);

    return () => {
      cancelled = true;
      const player = playerRef.current;
      if (player && container) {
        container.removeChild(player);
        playerRef.current = null;
      }
    };
  }, [swfUrl]);

  return (
    <div style={{ width: '100%', height: '100%', background: '#1a1a1a', display: 'flex', flexDirection: 'column' }}>
      <div
        ref={containerRef}
        style={{ width: '100%', flex: 1 }}
        data-testid="ruffle-container"
      />
    </div>
  );
};

export default RufflePlayer;
